<template>
  <b-row>
    <b-col sm="12">
      <b-card>
        <b-row>
          <b-col sm="7">
            <h4 id="traffic" class="card-title mb-0">Operaciones</h4>
            <div class="small text-muted">Operaciones de Depósito</div>
          </b-col>
          
          <b-col sm="5">
            <b-col sm="12" class="d-none d-md-block" v-if="!table.mostrarFiltros">
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" @click="table.mostrarFiltros=true" v-b-tooltip.hover title="Mostrar filtros">
                <i class="fa fa-filter"></i> Mostrar Filtros
              </b-button>
            </b-col>
            <b-col sm="12" class="d-none d-md-block" v-else>
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" v-if="table.mostrarFiltros" @click="table.mostrarFiltros=false" v-b-tooltip.hover title="Ocultar filtros">
                <i class="fa fa-window-close"></i>
              </b-button>
            </b-col>
          </b-col>                    
        </b-row>
      </b-card>

      <b-card id="list-operations" v-if="table.mostrarFiltros">
        <b-row >
          <b-col sm="10">            
            <b-row>            
              <b-col md="2" class="pr-0">
                <b-form-input type="date" size="md" v-model="filters.date_start" placeholder="Fecha Desde"></b-form-input>
              </b-col>
              <b-col md="2" class="pl-0">
                <b-form-input type="date" size="md" v-model="filters.date_end" placeholder="Fecha Hasta"></b-form-input>
              </b-col>
              <b-col md="3">
                <b-form-select
                  size="md"
                  v-model="filters.operation_filter"
                  :options="optOperationFilter"
                  @change="setOperationFilter()"
                ></b-form-select>
              </b-col>
              <b-col sm="2">
                <b-button variant="outline-dark" @click="filterOperations()" size="sm">
                  <b-icon icon="filter" class="mr-1" style="font-size:15px;"></b-icon>              
                  Filtrar
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="2">
            <b-link>
              <export-excel
                class = 'pull-right mt-3'
                :data = "arr.export"
                worksheet = "Listado de Operaciones en Depósito"
                name = "list-operations-deposit.xls">
                Exportar Datos
              </export-excel>            
            </b-link>
          </b-col>
        </b-row>              
      </b-card>

      <b-row>
        <b-col lg="8" class="pr-0" id="view_list_operations">
          <b-card>
            <b-row>
              <b-col>
                <b-form-group>
                  <b-input-group>
                    <b-form-input type="text" 
                                  placeholder="Ingrese su busqueda para filtrar la grilla" 
                                  v-model="table.filter"
                                  size="sm">
                    </b-form-input>              
                  </b-input-group>
                </b-form-group>            
              </b-col>
              <b-col>            
                <b-dropdown right text="Nueva Operación" variant="primary" size="sm" class="btn-pill float-right ml-2" v-b-tooltip.hover title="Nueva Operación">
                  <b-dropdown-item @click="add('add-manual')"><b-icon icon="plus-circle"></b-icon> Ingreso Manual</b-dropdown-item>
                  <b-dropdown-item @click="add('sub-manual')"><b-icon icon="plus-circle"></b-icon> Egreso Manual</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item @click="add('transferencia')"><b-icon icon="plus-circle"></b-icon> Transferencia entre Depósito</b-dropdown-item>
                </b-dropdown>      
              </b-col>
              <b-col sm="12">
                <b-table class="mb-0 table-operations-custom"
                        ref="table"
                        responsive
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="table.items"
                        :fields="table.fields"
                        :filter="table.filter"
                        :current-page="table.currentPage"
                        :per-page="table.perPage"
                        selectable
                        select-mode="single"
                        @row-selected="onRowSelected"  
                        :busy="table.isBusy"                      
                        v-if="table.items.length || table.isBusy">                       
                    
                    <template v-slot:table-colgroup="scope">
                      <col
                        v-for="field in scope.fields"                    
                        :key="field.key"
                        :style="{ width: field.width }"
                      >
                    </template> 

                    <template v-slot:table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando...</strong>
                      </div>
                    </template>

                    <template v-slot:cell(id)="data">
                      <div v-if="data.item.type">
                        {{data.item.type.name}} #{{data.item.number}}                        
                      </div>
                    </template>

                    <template v-slot:cell(date)="data">
                      {{moment(data.item.date).format('DD/MM/YYYY')}}
                    </template>

                    <template v-slot:cell(staff_id)="data">                      
                      <span v-if="data.item.staff_id" v-b-tooltip.hover :title="'STAFF: ' + data.item.staff.name"> 
                        <b-avatar :src="data.item.staff.image"
                                  v-if="data.item.staff.image">
                        </b-avatar>
                        <b-avatar v-else                                                                         
                                  variant="dark">
                        </b-avatar>              
                      </span>               
                    </template>
                                        
                    <template v-slot:cell(observations)="data">
                      <div v-if="data.item.observations && !isStockCountOperation(data.item)" v-b-tooltip.hover :title="data.item.observations">
                        <b-icon icon="chat-square-text"></b-icon>
                      </div>                                              
                    </template>

                    <template v-slot:cell(edit_source)="data">
                      <b-button
                        v-if="isStockCountOperation(data.item)"
                        :id="getStockCountPopoverId(data.item)"
                        variant="link"
                        size="sm"
                        class="p-0 stock-count-source-alert"
                        :class="getStockCountAlertClass(data.item)"
                      >
                        <b-icon icon="exclamation-triangle-fill"></b-icon>
                      </b-button>
                      <b-popover
                        v-if="isStockCountOperation(data.item)"
                        :target="getStockCountPopoverId(data.item)"
                        triggers="hover"
                        placement="right"
                        :custom-class="'stock-count-operation-popover ' + getStockCountAlertClass(data.item)"
                      >
                        <div class="stock-count-popover-title">
                          Ajuste generado por recuento
                        </div>
                        <div class="stock-count-popover-meta">
                          <div><strong>Staff:</strong> {{ data.item.staff ? data.item.staff.name : 'Sin staff' }}</div>
                          <div><strong>Fecha:</strong> {{ data.item.date ? moment(data.item.date).format('DD/MM/YYYY') : '-' }}</div>
                        </div>
                        <hr>
                        <div class="stock-count-popover-section">Contenido del ajuste</div>
                        <div
                          v-for="(activity, activityIndex) in data.item.activity"
                          :key="'stock-count-popover-activity-' + data.item.id + '-' + activityIndex"
                          class="stock-count-popover-row"
                        >
                          <div class="stock-count-popover-deposit">
                            <b-icon icon="building"></b-icon>
                            {{ getActivityDepositName(activity) }}
                          </div>
                          <div class="stock-count-popover-product" v-html="getDetailName(activity)"></div>
                          <div class="stock-count-popover-real">
                            <div class="stock-count-popover-real-label">Stock real ingresado</div>
                            <div v-html="formatStockCountUnits(getStockCountRealUnits(data.item, activity), ' / ')"></div>
                          </div>
                          <div class="stock-count-popover-qty" :class="activity.type_balance == '+' ? 'text-success' : 'text-danger'">
                            {{ activity.type_balance == '+' ? 'Se ajustó a la suba' : 'Se ajustó a la baja' }}:
                            <span v-html="formatStockCountUnits(getStockCountDiffUnits(data.item, activity), ' / ')"></span>
                          </div>
                        </div>
                      </b-popover>
                    </template>
                    
                    <template v-slot:cell(f_action)="data">
                      <b-dropdown right 
                                  text="Acción" 
                                  size="sm" 
                                  variant="outline-dark" 
                                  class="pull-right" 
                                  @show="setConfigTableOperationsShow"
                                  @hide="setConfigTableOperationsHide">
                        
                        <b-dropdown-item @click="sendPrinterOperation(data.item)">
                          <b-icon icon="printer"></b-icon> Imprimir
                        </b-dropdown-item>                          
                                                
                        <b-dropdown-header v-if="showDelete(data.item)">Acciones</b-dropdown-header>                      
                        <b-dropdown-item @click="remove(data.item)" v-if="showDelete(data.item)">
                          <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                </b-table>
                <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col lg="4" id="contain_details_items">
          <div id="details_items">
            <b-card>            
              <b-row>              
                <b-col md="12">
                  
                  <!-- OPERACION SELECCIONADA -->
                  <b-row class="mb-3">
                    <b-col md="8">
                      
                      <div class="crud-operations-title" v-if="itemSelected">
                        <div class="crud-operations-title">
                          <span v-if="itemSelected.type">                          
                            {{itemSelected.type.name}} #{{itemSelected.number}}
                          </span>           
                        </div>
                      </div>
                      
                    </b-col>
                    <b-col md="4">
                      <b-row>
                        <b-col md="12">
                          <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" @click="hideSub()" v-b-tooltip.hover title="Ocultar Detalle">
                            <i class="fa fa-window-close"></i>
                          </b-button>
                        </b-col>                      
                      </b-row>                   
                    </b-col>
                  </b-row>

                  <!-- DETALLE -->                
                  <b-row>
                    <b-col md="12">                         
                      <b-link v-if="tableSub.items.length" 
                              @click="openDetail()"
                              class="pull-right">
                        Ver detalle completo
                      </b-link>                                     
                      <b-table  class="mb-0 table-operations-sub"
                                responsive
                                head-variant="dark"
                                :hover="true"
                                :small="true"
                                :fixed="true"
                                :items="tableSub.items"
                                :fields="tableSub.fields"                            
                                v-if="tableSub.items.length">   
                        
                        <template v-slot:table-colgroup="scope">
                          <col
                            v-for="field in scope.fields"                    
                            :key="field.key"
                            :style="{ width: field.width }"
                          >
                        </template>                         

                        <template v-slot:cell(quantity)="row"> 
                          {{row.item.type_balance}} {{formatQuantity(row.item.quantity)}}
                          <span v-if="row.item.unit_measurement">{{row.item.unit_measurement.reference}}</span>
                        </template>

                        <template v-slot:cell(product)="row">
                          <div v-html="getDetailName(row.item)"></div>
                        </template>

                      </b-table>                      
                      <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
                    </b-col>                    
                  </b-row>
                </b-col>
              </b-row>
            </b-card>           
          </div>
        </b-col>
      </b-row>    

      <b-row>
        <b-col lg="8" class="pr-0" id="view_footer_operations">  
          <b-card>
            <b-row>
              <b-col>
                <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                  <i class="fa fa-angle-double-left"></i>
                  Volver
                </b-button>                        
              </b-col>

              <b-col>
                <nav v-if="table.tablePaginate">
                  <b-pagination class="pull-right mb-0"
                                size="sm"
                                pills=""
                                :total-rows="table.tablePaginate.total"
                                :per-page="table.tablePaginate.per_page"
                                v-model="table.currentPage"
                                @input="filterOperations()" />
                </nav>
              </b-col>          
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <!--
      ###########################
      ######### PRINTER #########
      ###########################
      -->
      <Printer v-if="crud.print.id" 
              :reference="crud.print.reference" 
              :registerID="crud.print.id"
              :key="crud.print.key"/>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close      
              header-bg-variant="dark"
              header-text-variant="white"
              size="xl"
              :key="modal.form._id"
              :id="modal.form._id">                  
        <div slot="modal-header" minimize>
          {{this.modal.form.title}}
        </div>

        <form-wizard  title=""
                      subtitle=""
                      nextButtonText="Siguiente"
                      backButtonText="Atrás"
                      finishButtonText="Guardar"
                      color="#2f353a"
                      shape="tab"
                      @on-complete="save"
                      class="crud-operations-wizard">

          <tab-content title="General" icon="fa fa-edit" :before-change="operationValidDetailGeneral">          
            <b-row>                    
              <b-col md="4">
                <b-form-group label="Fecha">
                  <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>                      
                </b-form-group>            
              </b-col>    
             
              <b-col md="12">
                <b-form-group label="Observaciones">
                  <b-form-textarea                
                    v-model="crud.form.observations"
                    placeholder="Ingresar las observaciones..."
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>                          
            </b-row>              
          </tab-content>

          <tab-content title="Detalle" icon="fa fa-list" :before-change="operationValidDetailItems">          
            <b-row>
              <b-col lg="12" md="12" sm="12">                                  
                <Detail @load-detail-products="setDetailItems($event, 'products')" 
                        @load-detail-products-compound="setDetailItems($event, 'productsCompound')" 
                        :operation="crud.form"
                        :detailProducts="crud.form.detailProducts"
                        :detailProductsCompound="crud.form.detailProductsCompound"/>                                             
              </b-col>        
            </b-row>
          </tab-content>
        </form-wizard>
        
        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="cancel()">Cancelar</b-button>              
        </div>                
      </b-modal>

      <!-- CRUD DETAILS -->
      <b-modal v-model="modal.detail.active"
              header-bg-variant="dark"
              header-text-variant="white"
              size="lg"
              :key="modal.detail._id"
              :id="modal.detail._id">                  
        <div slot="modal-header" minimize>
          {{this.modal.detail.title}}
        </div>
        <b-row>
          <b-col sm="12">                     
            <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
              <b-tab title="General">
                <table class="table table-hover table-sm" v-if="itemSelected">
                  <tbody>
                    <tr>
                      <td class="crud-operations-title-table-custom align-middle">ID</td>
                      <td class="crud-operations-value-table-custom align-middle">
                        <b>#{{this.itemSelected.id}}</b>
                      </td>
                    </tr>                     
                    <tr v-if="itemSelected.type">
                      <td class="crud-operations-title-table-custom align-middle">Comprobante</td>                      
                      <td class="crud-operations-value-table-custom align-middle">
                        <b>{{this.itemSelected.type.name + ' #' + this.itemSelected.number}}</b>
                      </td>
                    </tr>                                                           
                    <tr v-if="itemSelected.staff">
                      <td class="crud-operations-title-table-custom align-middle">Emisor</td>                      
                      <td class="crud-operations-value-table-custom align-middle">
                        <div>
                          {{itemSelected.staff.name}}  
                        </div>                        
                      </td>
                    </tr>                                                             
                    <tr>
                      <td class="crud-operations-title-table-custom align-middle">Fecha</td>
                      <td class="crud-operations-value-table-custom align-middle">
                        {{moment(this.itemSelected.date).format('DD MMMM YYYY')}}
                      </td>
                    </tr>      
                    <tr v-if="itemSelected.reference_origin">
                      <td class="crud-operations-title-table-custom align-middle">Origen</td>                      
                      <td class="crud-operations-value-table-custom align-middle">
                        <div>
                          {{itemSelected.reference_origin}}  
                        </div>                        
                      </td>
                    </tr>                                                            
                    <tr v-if="itemSelected.observations">
                      <td class="crud-operations-title-table-custom align-middle">Observaciones</td>
                      <td class="crud-operations-value-table-custom align-middle">                        
                        {{this.itemSelected.observations}}
                      </td>
                    </tr>                              
                  </tbody>
                </table>
              </b-tab>              
              <b-tab title="Items">                
                <b-table class="mb-0 table-full-detail-operations"
                        responsive
                        head-variant="dark"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableDetail.items"
                        :fields="tableDetail.fields"
                        v-if="tableDetail.items.length">                       
                    
                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"                    
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>           

                  <template v-slot:cell(code)="data">                           
                    <div v-html="getDetailCode(data.item)"></div>
                  </template>

                  <template v-slot:cell(product)="data">                           
                    <div v-html="getDetailName(data.item)"></div>
                  </template>

                  <template v-slot:cell(quantity)="data">   
                    {{data.item.type_balance}} {{formatQuantity(data.item.quantity)}}
                    <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
                  </template>
                  
                  <template v-slot:cell(deposit)="data">   
                    {{data.item.location.zone.deposit.reference}} / {{data.item.location.zone.reference}} / {{data.item.location.reference}}
                  </template>

                </b-table>
                <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
              </b-tab>
            </b-tabs>

          </b-col>
        </b-row>
        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.detail.active=false">Cancelar</b-button>                   
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import FindObject from '@/components/inc/find/findObject'  
  import Printer from '@/components/inc/printer/printer'
  import Detail from '@/components/inc/cpbtDetailDeposit/detail.vue'
  import moment from 'moment'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'

  export default {
    components: {
      FindObject,
      Printer,
      Detail,
      FormWizard,
      TabContent,      
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.DEPOSITOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudDepositsOperations',
          elements: {}
        },
        table : {
          items: [],
          fields: [],
          filter: null,
          mostrarFiltros: true,
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,          
        },     
        tableSub : {
          items: [],
          fields: []
        },            
        tableDetail : {
          items: [],
          fields: []
        },            
        crud: {
          form: {
            id: 0,
            date: '',                        
            type: null,          
            type_id: 0,              
            number: 0,                       
            observations: '',            
            staff_id: 0,            
            detailProducts: [],
            detailProductsCompound: [],    
            reference: '',          
          },            
          print: {
            reference: 'deposit-operation',
            id: 0,
            key: 0,
          }               
        },
        modal: {
          form: {
            active: false,
            title: '',
          },
          detail: {
            active: false, 
            title: '',
          },            
        },          
        arr: {
          operations: [],   
          export: [],           
        },           
        filters: {
          date_start: '',
          date_end: '',
          type_reference: '',
          edit_source: '',
          operation_filter: '',
        },
        optOperationFilter: [
          { value: '', text: 'Todos los movimientos' },
          {
            label: 'Tipos de operación',
            options: [
              { value: 'type:add-manual', text: 'Ingreso manual' },
              { value: 'type:sub-manual', text: 'Egreso manual' },
              { value: 'type:transferencia', text: 'Transferencia entre depósito' },
              { value: 'type:sub-remito', text: 'Egreso desde venta' },
              { value: 'type:add-remito', text: 'Ingreso desde remito de compra' },
              { value: 'type:return-nc', text: 'Devolución por nota de crédito' },
            ]
          },
          {
            label: 'Origen',
            options: [
              { value: 'source:stockCount', text: 'Ajustes por recuento' },
            ]
          },
        ],
        itemSelected: null,             
      }
    },
    created () {     
        /* Configurar permisos de vistas y elementos */
        Helper.hasAccessView(this.access)
        /* Fin configuracion */
    },     
    mounted() {   
      this.loadFieldTable()
      this.filterLoad()   
      this.filterOperations()              
      this.loadStyleConfig()

      this._start = true
    },  
    activated() {
      if(this._start) {
        this._start = false
        return false
      } 

      this.filterLoad()   
      this.filterOperations()              
    },         
    methods: {
      // CONFIGURACION
      loadStyleConfig () {        
        var view_list_operations = document.getElementById('view_list_operations')
        var view_footer_operations = document.getElementById('view_footer_operations')

        var padre = document.getElementById('contain_details_items')
        var hijo = document.getElementById('details_items')  
              
        hijo.style.width = padre.clientWidth - 45 + 'px'

        if(window.innerWidth < 991) {
          hijo.style.width = '100%'
          hijo.style.position = "relative"
          hijo.style.right = 'auto'

          view_list_operations.classList.remove('pr-0')
          view_footer_operations.classList.remove('pr-0')
        } else {          
          view_list_operations.classList.add('pr-0')
          view_footer_operations.classList.add('pr-0')
        }        
      },
      loadFieldTable () {
        // TABLE OPERATIONS        
        this.table.fields.push({key: 'staff_id', label: 'Staff', class:"align-middle text-left", width:"50px"})        
        this.table.fields.push({key: 'date', label: 'Fecha', class:"align-middle text-left", width:"80px"})                            
        this.table.fields.push({key: 'id', label: 'Nº Operación', sortable: true, class:"align-middle text-left", width:"100px"})        
        this.table.fields.push({key: 'observations', label: '', class:"align-middle text-center", width:"100px"})                        
        this.table.fields.push({key: 'edit_source', label: '', class:"align-middle text-center", width:"45px"})
        this.table.fields.push({key: 'f_action', label:'', class:"align-middle", width:"60px"})

        // TABLE DETALLE
        this.tableSub.fields.push({key: 'quantity', label: 'Cantidad', class:"align-middle", width:"50px"})                
        this.tableSub.fields.push({key: 'product', label: 'Item', class:"align-middle", width:"150px"})                

        // TABLE DETALLE COMPLETO        
        this.tableDetail.fields.push({key: 'code', label: 'Código', class:"align-middle", width:"50px"})                
        this.tableDetail.fields.push({key: 'product', label: 'Item', class:"align-middle text-truncate", width:"200px"})                                         
        this.tableDetail.fields.push({key: 'deposit', label: 'Deposito/Zona/Ubicación', class:"align-middle text-left", width:"150px"})          
        this.tableDetail.fields.push({key: 'quantity', label: 'Cantidad', class:"align-middle text-right", width:"60px"})                     
      },      
      getRowCount (items) {
        return items.length
      },
      formatQuantity(value) {
        const num = parseFloat(value)
        if (Number.isNaN(num)) {
          return (0).toFixed(4)
        }
        return num.toFixed(4)
      },
      setOperationFilter() {
        this.filters.type_reference = ''
        this.filters.edit_source = ''

        if(!this.filters.operation_filter) {
          return
        }

        var parts = this.filters.operation_filter.split(':')
        if(parts[0] == 'type') {
          this.filters.type_reference = parts[1]
        }
        if(parts[0] == 'source') {
          this.filters.edit_source = parts[1]
        }
      },
      isStockCountOperation(item) {
        return item && item.edit_source == 'stockCount'
      },
      getStockCountPopoverId(item) {
        return 'stock-count-operation-popover-' + item.id
      },
      getActivityDepositName(activity) {
        if(activity && activity.location && activity.location.zone && activity.location.zone.deposit) {
          return activity.location.zone.deposit.name
        }
        return 'Sin depósito'
      },
      getStockCountData(item) {
        if(!item || !item.observations) return null
        try {
          var data = JSON.parse(item.observations)
          return data && data.source == 'stockCount' ? data : null
        } catch (e) {
          return null
        }
      },
      getStockCountRealUnits(item, activity) {
        var data = this.getStockCountData(item)
        if(data) {
          return this.getStockCountUnits(data.real_purchase, data.purchase_unit, data.real_sale, data.sale_unit)
        }
        return this.getStockCountUnits(activity.quantity, activity.unit_measurement ? activity.unit_measurement.reference : '', activity.quantity_sale, activity.unit_measurement_sale_reference)
      },
      getStockCountDiffUnits(item, activity) {
        var data = this.getStockCountData(item)
        if(data) {
          return this.getStockCountUnits(Math.abs(data.diff_purchase), data.purchase_unit, Math.abs(data.diff_sale), data.sale_unit)
        }
        return this.getStockCountUnits(activity.quantity, activity.unit_measurement ? activity.unit_measurement.reference : '', activity.quantity_sale, activity.unit_measurement_sale_reference)
      },
      getStockCountUnits(purchaseQuantity, purchaseUnit, saleQuantity, saleUnit) {
        var units = [{
          quantity: purchaseQuantity,
          unit: purchaseUnit || ''
        }]

        if(saleQuantity !== undefined && saleQuantity !== null && saleUnit && saleUnit != purchaseUnit) {
          units.push({
            quantity: saleQuantity,
            unit: saleUnit
          })
        }

        return units
      },
      formatStockCountUnits(units, separator = ' ') {
        return units
          .map(unit => '<span class="stock-count-popover-unit">' + this.formatQuantity(unit.quantity) + (unit.unit ? ' ' + unit.unit : '') + '</span>')
          .join(separator)
      },
      getStockCountAlertClass(item) {
        var type = this.getStockCountMovementType(item)
        if(type == 'add') return 'stock-count-movement-add'
        if(type == 'sub') return 'stock-count-movement-sub'
        return 'stock-count-movement-mixed'
      },
      getStockCountMovementType(item) {
        var hasAdd = false
        var hasSub = false
        if(item && item.activity) {
          item.activity.forEach(activity => {
            if(activity.type_balance == '+') hasAdd = true
            if(activity.type_balance == '-') hasSub = true
          })
        }
        if(hasAdd && !hasSub) return 'add'
        if(hasSub && !hasAdd) return 'sub'
        return 'mixed'
      },
      onRowSelected(item) {         
        this.arr.operations.forEach((element, index) => {
          this.table.items[index]._showDetails = false
          if(item.length){
            if(element.id == item[0].id) {  
              this.openSub(element)                             
            }
          }
        })
      },   
      setConfigTableOperationsShow() {
        var arrTable = document.getElementsByClassName('table-operations-custom')
        var i = 0
        for(i=0; i<arrTable.length; i++) {          
          arrTable[i].style.minHeight = '150px'
        }        
      },
      setConfigTableOperationsHide() {
        var arrTable = document.getElementsByClassName('table-operations-custom')
        var i = 0
        for(i=0; i<arrTable.length; i++) {
          arrTable[i].style.minHeight = 'auto'
        }        
      },  
      setConfigTableSubShow() {
        var arrTable = document.getElementsByClassName('table-operations-sub')
        var i = 0
        for(i=0; i<arrTable.length; i++) {
          arrTable[i].style.minHeight = '210px'
        }        
      },
      setConfigTableSubHide() {
        var arrTable = document.getElementsByClassName('table-operations-sub')
        var i = 0
        for(i=0; i<arrTable.length; i++) {
          arrTable[i].style.minHeight = 'auto'
        }        
      },  

      // SELECT         
      prepareExport(data) {              
        this.arr.export = []
        data.forEach(element => {
          var voucherReference = ""
 
          if(element.type) {            
            voucherReference = element.type.name + ' #' + element.number
          }          

          this.arr.export.push({
            id: element.id,
            date: element.date,                                  
            voucherReference: voucherReference,                          
            observations: element.observations,
            productID: 0,
            productCode: "",
            productName: "",            
            productCompoundID: 0,
            productCompoundName: "",                                          
            type_balance: "",
            quantity: 0,
            unitMeasurementID: 0,
            unitMeasurementName: "",                        
          })

          element.activity.forEach(element1 => {
            var productID = 0
            var productCode = ""
            var productName = ""
            var productCompoundID = 0
            var productCompoundName = ""     
            var unitMeasurementID = 0
            var unitMeasurementName = ""               

            if(element1.products_id) {
              productID = element1.product.id
              productCode = element1.product.code
              productName = element1.product.name            
            }

            if(element1.products_colors_id) {
              productID = element1.products_color.id
              productCode = element1.products_color.code
              productName = element1.products_color.name + " (" + element1.products_color.color.name + ")"
            }            

            if(element1.products_waist_id) {
              productID = element1.products_waist.id
              productCode = element1.products_waist.code
              productName = element1.products_waist.name + " (" + element1.products_waist.waist.name + ")"
            }            

            if(element1.products_color_waist_id) {
              productID = element1.products_color_waist.id
              productCode = element1.products_color_waist.code
              productName = element1.products_color_waist.name + " (" + element1.products_color_waist.color.name + " - " + element1.products_color_waist.waist.name + ")"
            }       
          
            if(element1.products_compound_id) {
              productCompoundID = element1.products_compound.id
              productCompoundName = element1.products_compound.name            
            }    

            if(element1.unit_measurement_id) {
              unitMeasurementID = element1.unit_measurement.id
              unitMeasurementName = element1.unit_measurement.name            
            }            

            this.arr.export.push({
              productID: productID,
              productCode: productCode,
              productName: productName,
              productCompoundID: productCompoundID,
              productCompoundName: productCompoundName,                                          
              type_balance: element1.type_balance,
              quantity: element1.quantity,
              unitMeasurementID: unitMeasurementID,
              unitMeasurementName: unitMeasurementName,              
            })
          })
        });
      },

      // ABM MAIN
      add(type) {
        this.crud.form.id = 0           
        this.crud.form.date = moment().format('YYYY-MM-DD')        
        this.crud.form.observations = ''
        this.crud.form.staff_id = Helper.getStaffId()        
        this.crud.form.detailProducts = []
        this.crud.form.detailProductsCompound = []
        this.crud.form.reference = type       

        this.searchVoucher()
        
        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nueva Operación"
        this.modal.form.active = true
      },       
      remove(item) {
        this.crud.form.id = item.id

        var voucher = "ID #" + item.id
        
        if(item.type) {
          voucher = item.type.name + '- #' + item.number.toString().padStart(8,'0')
        }         

        this.$bvModal.msgBoxConfirm('¿Desea borrar la operación ' + voucher + '?', {
          title: 'Borrar Operación',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarOperacion(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()
              this.filterOperations()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },      
      save() {
        this.$bvModal.msgBoxConfirm('¿Desea continuar con la operación?', {
          title: 'Guardar Operación',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'GUARDAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {          
            let loader = this.$loading.show();
            
            if (this.crud.form.id) {
              var result = serviceAPI.editarOperacion(this.crud.form);
            } else {
              var result = serviceAPI.agregarOperacion(this.crud.form);
            }

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.filterOperations()
              this.$awn.success("Operación guardad con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })              
      },          
      cancel() {
        this.$bvModal.msgBoxConfirm('¿Desea cancelar la operación?', {
          title: 'Cancelar el Operación',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {        
            this.modal.form.active = false
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })   
      },
      setDetailItems(event, type) {         
        if(type=="products") {
          this.crud.form.detailProducts = event                
        } 
        if(type=="productsCompound") {          
          this.crud.form.detailProductsCompound = event                
        }              
      },         
      operationValidDetailGeneral() {        
        return true;        
      },
      operationValidDetailItems() {
          if( this.crud.form.detailProducts.length || 
              this.crud.form.detailProductsCompound.length) { 
            return true;
          } else {
            this.$awn.alert("No se cargó ningún item");
            return false;
          }
      },
      showDelete(item) {        
        if(item.type.reference == 'add-manual' || item.type.reference == 'sub-manual' || item.type.reference == 'transferencia' ) {
          return true
        } else {
          return false
        }
      },

      // SELECT VOUCHER 
      searchVoucher() {
        if(!this.crud.form.id) {
          if(this.crud.form.reference) {
            var result = serviceAPI.obtenerVoucherByReference({
              'reference': this.crud.form.reference,              
            });
            result.then((response) => {                               
              this.crud.form.type = response.data                            
              this.crud.form.number = response.data.number  
              
              if( this.crud.form.type ) {              
                this.modal.form.title = this.crud.form.type.name                
                this.modal.form.title = this.modal.form.title + ' #' + this.crud.form.number
              }
                          
            })           
          }
        } 
      },

      // FILTER
      filterLoad() {      
        this.filters.date_start = moment().subtract(30, 'days').format('YYYY-MM-DD') 
        this.filters.date_end = moment().format('YYYY-MM-DD') 
      },          
      filterOperations(forceOpenSub=false) {
        this.table.isBusy = true
        var result = serviceAPI.filtrarOperacion(this.filters, this.table.currentPage)        
        result.then((response) => {          
          var data = response.data
          this.table.tablePaginate = data

          this.table.items = data.data
          this.arr.operations = data.data
          this.prepareExport(data.data)
          
          this.table.items.forEach(element => {            
            if(forceOpenSub) {
              if(element.id == this.itemSelected.id) {
                this.openSub(element)
              }              
            }                
          });

          if(this.table.rowSelected!=null) {            
            this.table.items[this.table.rowSelected]._showDetails = true                   
          }         

          if(this.$refs.table) {            
            this.$refs.table.$forceUpdate()
          }          
          
          this.table.isBusy = false
        })           
        .catch(error => { 
          this.table.isBusy = false  
          this.$awn.alert(ErrorToken.valid(error));
        })  
      },    

      // OPERATION DETAIL
      openSub(item) {                
        this.itemSelected = item        

        this.tableSub.items = item.activity           
        this.loadStyleConfig()
      },    
      hideSub() {
        this.tableSub.items=[]
        this.itemSelected = null
      },               
      openDetail() {              
        this.tableDetail.items = this.itemSelected.activity

        this.modal.detail._id = Math.random().toString(36).slice(2, 8)
        this.modal.detail.title = "Detalle de la operación"
        this.modal.detail.active = true
      }, 
      getDetailCode(item) {        
        if(item.products_id || item.products_colors_id || item.products_waist_id || item.products_color_waist_id) {
          return this.getProductCode(item)
        }            
        if(item.products_compound_id) {          
          return item.products_compound.code
        }                
      },
      getDetailName(item) {        
        if(item.products_id || item.products_colors_id || item.products_waist_id || item.products_color_waist_id) {
          return this.getProductName(item)
        }               
        if(item.products_compound_id) {          
          return item.products_compound.name
        }                
      },       
      getProductCode(item) {
        if(item.products_id) {
          return item.product.code
        }

        if(item.products_colors_id) {
          var prod = item.products_color 
          return prod.code
        }

        if(item.products_waist_id) {
          var prod = item.products_waist 
          return prod.code
        }

        if(item.products_color_waist_id) {
          var prod = item.products_color_waist 
          return prod.code
        }
      },      
      getProductName(item) {
        if(item.products_id) {
          return item.product.name
        }

        if(item.products_colors_id) {
          var prod = item.products_color 
          return prod.name + ' (' + prod.color.name + ')'
        }

        if(item.products_waist_id) {
          var prod = item.products_waist 
          return prod.name + ' (' + prod.waist.name + ')'
        }

        if(item.products_color_waist_id) {
          var prod = item.products_color_waist 
          return prod.name + ' (' + prod.color.name + ' - ' + prod.waist.name + ')'
        }
      },

      // PRINT
      sendPrinterOperation(item) {
        this.crud.print.key=Math.random()
        this.crud.print.id=item.id
      }      
    }
  }
</script>
<style>
  .crud-operations-title {
    font-size: 15px;
    font-weight: 600;
  } 
  .stock-count-source-alert {
    color: #f0ad4e;
    font-size: 1rem;
    line-height: 1;
  }
  .stock-count-source-alert.stock-count-movement-add {
    color: #4dbd74;
  }
  .stock-count-source-alert.stock-count-movement-sub {
    color: #f86c6b;
  }
  .stock-count-source-alert.stock-count-movement-mixed {
    color: #f0ad4e;
  }
  .stock-count-source-alert.stock-count-movement-add:hover {
    color: #2f9d55;
  }
  .stock-count-source-alert.stock-count-movement-sub:hover {
    color: #d9534f;
  }
  .stock-count-source-alert.stock-count-movement-mixed:hover {
    color: #d9831f;
  }
  .stock-count-operation-popover {
    max-width: 360px;
  }
  .stock-count-operation-popover.stock-count-movement-add {
    border-color: #9fdab4;
  }
  .stock-count-operation-popover.stock-count-movement-sub {
    border-color: #f5b5b5;
  }
  .stock-count-operation-popover.stock-count-movement-mixed {
    border-color: #f0d98a;
  }
  .stock-count-operation-popover .popover-body {
    border-radius: 0.25rem;
    font-size: 0.85rem;
    min-width: 320px;
  }
  .stock-count-operation-popover.stock-count-movement-add .popover-body {
    color: #235734;
    background: #eaf8ef;
  }
  .stock-count-operation-popover.stock-count-movement-sub .popover-body {
    color: #7a2b2b;
    background: #fdecec;
  }
  .stock-count-operation-popover.stock-count-movement-mixed .popover-body {
    color: #5f4b00;
    background: #fff3cd;
  }
  .stock-count-operation-popover hr {
    margin: 0.5rem 0;
  }
  .stock-count-operation-popover.stock-count-movement-add hr {
    border-top-color: #bfe6cc;
  }
  .stock-count-operation-popover.stock-count-movement-sub hr {
    border-top-color: #f3c3c3;
  }
  .stock-count-operation-popover.stock-count-movement-mixed hr {
    border-top-color: #e6d27a;
  }
  .stock-count-popover-title {
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03rem;
    margin-bottom: 0.4rem;
  }
  .stock-count-popover-meta {
    line-height: 1.45;
  }
  .stock-count-popover-section {
    font-weight: 700;
    margin-bottom: 0.35rem;
  }
  .stock-count-popover-row {
    padding-top: 0.35rem;
  }
  .stock-count-popover-row + .stock-count-popover-row {
    border-top: 1px solid #e6d27a;
    margin-top: 0.35rem;
  }
  .stock-count-popover-deposit {
    font-size: 0.76rem;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 0.25rem;
    opacity: 0.82;
  }
  .stock-count-popover-qty {
    font-weight: 700;
    margin-top: 0.45rem;
  }
  .stock-count-popover-real {
    margin-top: 0.45rem;
    padding: 0.45rem 0.55rem;
    border-radius: 0.35rem;
    background: rgba(32, 168, 216, 0.12);
    color: #165d78;
    font-size: 0.95rem;
  }
  .stock-count-popover-real-label {
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    margin-bottom: 0.15rem;
  }
  .stock-count-popover-unit {
    display: inline-block;
    margin-right: 0.35rem;
    font-weight: 700;
  }
  .stock-count-popover-product {
    margin-top: 0.15rem;
  }
  #details_items {
    position: fixed;
    right: 15px;    
  }     
  .table-operations-sub {
    overflow: auto;
    max-height: 350px;
  }
  .crud-operations-title-table-custom {
    color: #fff;
    background-color: #2f353a;
    border-color: #40484f;
    font-weight: 700;
    padding-right: 10px;
    width: 30%;
    text-align: right
  }
  .crud-operations-value-table-custom {
    padding-left: 5px;
  }  
  .table-full-detail-operations {
    overflow: auto;
    max-height: 350px;    
  }
  .operations-alert-retailer {
    font-weight: bold;
    color: gray;
    font-size: 12px;
  }
  .operations-alert-noretailer {
    font-weight: bold;
    color: darkblue;
    font-size: 12px;
  } 
  .operation-total-table-paid {
    color: darkgreen;
    font-weight: 700;
  } 
  .operation-total-table-nopaid {
    color: darkred;
    font-weight: 700;
  }
  .crud-operations-nro-internal {
    color: var(--mdc-theme-primary);
    font-size: 12px;
  }
  .crud-new-operations-button-add {
    margin-top: 29px;
  }
  .crud-operations-totales-items-header {
    background: var(--dark);
    color: #fff;
    font-size: 12px;
    padding-right: 10px;
    padding-top: 2px;
    padding-bottom: 2px;    
    text-align: right;
    font-weight: 700;
  }
  .crud-operations-counts-items {
    font-size: 12px;    
    text-align: right;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;    
    border-color: var(--dark);
    border-style: solid;
    border-width: 1px;    
  }  
  .crud-operations-totales-items {
    font-size: 12px;    
    text-align: right;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;    
    border-color: var(--dark);
    border-style: dotted;
    border-width: 1px;    
  }  
  .crud-operations-totales-items-amount {
    font-size: 15px;    
    text-align: right;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;    
    border-color: var(--dark);
    border-style: dotted;    
    border-width: 1px;    
  }    
  .crud-operations-wizard .wizard-header {
    padding: 0px;
  }  
  .crud-operations-totales-discounts-items {
    padding-top: 5px;
  }
</style>
